import { MenuItem as CssModulesMenuItem, MenuLinkItem as CssModulesMenuLinkItem } from '@sunwebgroup/uds-ui/menu'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/menu' instead.
 */
export const MenuItem = Object.assign(
  styled(CssModulesMenuItem)``,
  { displayName: 'MenuItem' },
)

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/menu' instead.
 */
export const MenuLinkItem = Object.assign(
  styled(CssModulesMenuLinkItem)``,
  { displayName: 'MenuLinkItem' },
)
